import { environment } from "../../shared/utils/enum";
export const envConfig = {
  PUBLIC_URL: "https://app-fleetmanagement-hml-001.azurewebsites.net/",
  REACT_APP_ENVIRONMENT_NAME: environment.homologation,
  REACT_APP_NAME: "$npm_package_name",
  REACT_APP_VERSION: "$npm_package_version",
  REACT_APP_API_URL: "https://app-fleetmanagement-hml-002.azurewebsites.net/api/v1/",
  REACT_APP_CLARITY_KEY: "7dfrzijx99"
};
